import PurchaseEventView from '../components/PurchaseEventView';
export default PurchaseEventView;
